import React from "react";
import { Body2 } from "@activecollab/components";
import PropTypes from "prop-types";

const StorageUsage = ({ storage, storageUsage }) => {
  if (storageUsage.storage_level === "full" || storageUsage.storage_level === "high") {
    return (
      <Body2
        data-testid="type-with-color"
        color={storageUsage.storage_level === "full" ? "alert" : "warning"}
      >
        {storage} ({storageUsage?.storage_percent}%)
      </Body2>
    );
  }
  return (
    <Body2
      color="tertiary"
      data-testid="type-with-default-color"
    >
      {storage} ({storageUsage?.storage_percent}%)
    </Body2>
  );
};

StorageUsage.propTypes = {
  storage: PropTypes.string,
  storageUsage: PropTypes.object,
};

export default StorageUsage;
